import { render } from "./MPopup.vue?vue&type=template&id=f5ebc36e&scoped=true"
import script from "./MPopup.vue?vue&type=script&lang=js"
export * from "./MPopup.vue?vue&type=script&lang=js"

import "./MPopup.vue?vue&type=style&index=0&id=f5ebc36e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ebc36e"]])

export default __exports__